export default __webpack_public_path__ + "static/studycafe-office3-4af2d4aade4f1d9ca784f9e1204fedb0.jpg";